<template>
  <div>
    <div class="header py-5 py-lg-7 pt-lg-7">
      <!--   <b-container>
        <div class="header-body text-center mb-7">
          <b-row class="justify-content-center">
            <b-col xl="5" lg="6" md="8" class="px-5">
              <h1 class="text-white">Solicitar nova senha</h1>
            </b-col>
          </b-row>
        </div>
      </b-container> -->
      <!--   <div class="separator separator-bottom separator-skew zindex-100">
        <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon
            class="fill-default"
            points="2560 0 2560 100 0 100"
          ></polygon>
        </svg>
      </div> -->
    </div>

    <!-- Page content -->
    <b-container class="mt--8 pb-0">
      <b-row class="justify-content-center pt-5">
        <b-col lg="5" md="7">
          <b-card no-body class="bg-light">
            <b-card-body class="" style="padding-left: 40px; padding-right: 40px;">
              <span class="w-100 d-block text-center">
                <img src="img/janoo-logo-v2-high-color.png" style="max-width: 280px; height: auto"
                  class="pt-4 pb-3 justify-content-center align-items-center display-flex" />
              </span>

              <div v-if="true" style="color: #3E3E3E;" class="mb-1 pt-3">
                <h3 class="pb-2">Solicitar nova Senha</h3>
                <!-- small style="font-weight: 600; color: gray;">Usuário ou e-mail</small-->
              </div>

              <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
                <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
                  <base-input v-model="form.email" id="input-email" type="text" alternative class="mb-3" name="email" :rules="{ required: true }"
                    prepend-icon="ni ni-email-83" placeholder="email de cadastro">
                  </base-input>

                  <b-alert :show="showAlert" dismissible variant="danger">
                    <span class="alert-text">{{ errorText }}</span>
                  </b-alert>

                  <div class="text-center pt-3">
                    <base-button type="primary" native-type="submit" :disabled="disableLoginButton" class="my-1 mb-3 btn-block">
                      Solicitar nova senha
                    </base-button>

                    <a href="/login">
                      <base-button type="outline-primary" class="mt-2 btn-block">Voltar</base-button>
                    </a>
                  </div>

                  <b-row class="mt-3">
                    <div class="text-gray text-center w-100 pb-5">
                      <a href="/register" class="text-gray" style="font-size: 14px; text-decoration-line: underline">Criar nova conta</a>
                    </div>
                  </b-row>

                </b-form>
              </validation-observer>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import swal from 'sweetalert2'

export default {
  name: 'ForgotPassword',

  data() {
    return {
      form: {
        email: '',
      },
      showAlert: false,
      errorText: '',
      loginButtonText: 'Logar',
      disableLoginButton: false,
    }
  },

  computed: {
    ...mapGetters('login', {
      forgotPasswordUser: 'getForgotPasswordUser',
      forgotPasswordMessage: 'getForgotPasswordMessage',
      forgotPasswordError: 'getForgotPasswordError',
    }),
  },

  watch: {
    forgotPasswordMessage(newValue, oldValue){
      if(newValue != undefined && newValue != null && newValue.length > 0){
        this.showSwal('Código enviado por email!', newValue, 'primary', 'success')
        const forgotten = btoa(true)
        this.$router.push({ name: 'ResetPassword', params: { forgottenPassword: forgotten } })
        this.disableLoginButton = false
      }
    },

    forgotPasswordError(newValue, oldValue){
      if(newValue != undefined && newValue != null && newValue.length > 0){
        this.disableLoginButton = false
        this.showSwal('Erro ao solicitar código', newValue, 'primary', 'warnning')
      }
    },

  },

  methods: {
    ...mapActions('login', [
      'forgotPassword',
    ]),

    async onSubmit() {
      this.showAlert = false
      this.loginButtonText = 'Enviando...'
      this.disableLoginButton = true;

      await this.forgotPassword(this.form.email)
        .then(() => {
          this.$emit("closeResetPasswordModal")
        })
    },

    showSwal(title, text, btn, icon) {
      swal.fire({
        title: title,
        html: text,
        buttonsStyling: false,
        confirmButtonClass: `btn btn-${btn}`,
      })
    },

  },

  created() {
    console.log('########', process.env.NODE_ENV, ' mode #######')
  },

  async mounted() {
  },

}
</script>

<style lang="css">
#input-email .invalid-feedback {
  position: absolute;
  text-align: right;
  float: right;
  right: 0px;
  padding-right: 3rem !important;
}
</style>
